import type { ReactNode } from 'react';
import type { Query } from '../data/console-context.tsx';

export function Page(props: { title: string; summary: string; children: ReactNode }) {
  return (
    <>
      <h1 id="page-title">{props.title}</h1>
      <p className="summary">{props.summary}</p>
      {props.children}
    </>
  );
}

export function Loaded<T>(props: { query: Query<T>; children: (value: T) => ReactNode }) {
  const { query } = props;
  if (query.status === 'loading') return <p role="status">Loading…</p>;
  if (query.status === 'error') return <p role="alert">{query.message}</p>;
  return <>{props.children(query.value)}</>;
}
